"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");
var TimeoutScheduler_1 = require("../scheduler/TimeoutScheduler");
var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");
var Versioning_1 = require("../versioning/Versioning");
var WebSocketReadyState_1 = require("../websocketadapter/WebSocketReadyState");
var SignalingClientEvent_1 = require("./SignalingClientEvent");
var SignalingClientEventType_1 = require("./SignalingClientEventType");
/**
 * [[DefaultSignalingClient]] implements the SignalingClient interface.
 */
var DefaultSignalingClient = /*#__PURE__*/function () {
  function DefaultSignalingClient(webSocket, logger) {
    var _this = this;
    _classCallCheck(this, DefaultSignalingClient);
    this.webSocket = webSocket;
    this.logger = logger;
    this.unloadHandler = null;
    this.closeEventHandler = function (event) {
      _this.deactivatePageUnloadHandler();
      _this.resetConnection();
      _this.sendEvent(new SignalingClientEvent_1.default(_this, SignalingClientEventType_1.default.WebSocketClosed, null, event.code, event.reason));
      _this.serviceConnectionRequestQueue();
    };
    this.observerQueue = new Set();
    this.connectionRequestQueue = [];
    this.resetConnection();
    this.logger.debug(function () {
      return 'signaling client init';
    });
    this.audioSessionId = this.generateNewAudioSessionId();
  }
  _createClass(DefaultSignalingClient, [{
    key: "registerObserver",
    value: function registerObserver(observer) {
      this.logger.debug(function () {
        return 'registering signaling client observer';
      });
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.logger.debug(function () {
        return 'removing signaling client observer';
      });
      this.observerQueue.delete(observer);
    }
  }, {
    key: "openConnection",
    value: function openConnection(request) {
      this.logger.info('adding connection request to queue: ' + request.url());
      this.connectionRequestQueue.push(request);
      this.closeConnection();
    }
  }, {
    key: "pingPong",
    value: function pingPong(pingPongFrame) {
      this.logger.debug(function () {
        return 'sending ping';
      });
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.PING_PONG;
      message.pingPong = pingPongFrame;
      this.sendMessage(message);
      return message.timestampMs;
    }
  }, {
    key: "join",
    value: function join(settings) {
      this.logger.info('sending join');
      var joinFrame = SignalingProtocol_js_1.SdkJoinFrame.create();
      joinFrame.protocolVersion = 2;
      joinFrame.flags = SignalingProtocol_js_1.SdkJoinFlags.HAS_STREAM_UPDATE;
      var browserBehavior = new DefaultBrowserBehavior_1.default();
      if (browserBehavior.supportsSenderSideBandwidthEstimation()) {
        joinFrame.flags |= SignalingProtocol_js_1.SdkJoinFlags.USE_SEND_SIDE_BWE;
      }
      joinFrame.flags |= settings.sendBitrates ? SignalingProtocol_js_1.SdkJoinFlags.SEND_BITRATES : 0;
      var sdkClientDetails = {
        platformName: browserBehavior.name(),
        platformVersion: browserBehavior.version(),
        clientSource: Versioning_1.default.sdkName,
        chimeSdkVersion: Versioning_1.default.sdkVersion
      };
      if (settings.applicationMetadata) {
        var _settings$application = settings.applicationMetadata,
          appName = _settings$application.appName,
          appVersion = _settings$application.appVersion;
        sdkClientDetails.appName = appName;
        sdkClientDetails.appVersion = appVersion;
      }
      joinFrame.clientDetails = SignalingProtocol_js_1.SdkClientDetails.create(sdkClientDetails);
      joinFrame.audioSessionId = this.audioSessionId;
      joinFrame.wantsCompressedSdp = DefaultSignalingClient.CLIENT_SUPPORTS_COMPRESSION;
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.JOIN;
      message.join = joinFrame;
      this.sendMessage(message);
    }
  }, {
    key: "subscribe",
    value: function subscribe(settings) {
      var subscribeFrame = SignalingProtocol_js_1.SdkSubscribeFrame.create();
      subscribeFrame.sendStreams = [];
      subscribeFrame.sdpOffer = settings.sdpOffer;
      if (settings.connectionTypeHasVideo) {
        subscribeFrame.receiveStreamIds = settings.receiveStreamIds;
      }
      if (settings.audioHost) {
        subscribeFrame.audioCheckin = settings.audioCheckin;
        subscribeFrame.audioHost = settings.audioHost;
        subscribeFrame.audioMuted = settings.audioMuted;
        if (!settings.audioCheckin) {
          var audioStream = SignalingProtocol_js_1.SdkStreamDescriptor.create();
          audioStream.mediaType = SignalingProtocol_js_1.SdkStreamMediaType.AUDIO;
          audioStream.trackLabel = 'AmazonChimeExpressAudio';
          audioStream.attendeeId = settings.attendeeId;
          audioStream.streamId = 1;
          audioStream.groupId = 1;
          audioStream.framerate = 15;
          audioStream.maxBitrateKbps = 600;
          audioStream.avgBitrateBps = 400000;
          subscribeFrame.sendStreams.push(audioStream);
        }
      }
      subscribeFrame.compressedSdpOffer = settings.compressedSdpOffer;
      subscribeFrame.duplex = SignalingProtocol_js_1.SdkStreamServiceType.RX;
      if (settings.localVideoEnabled) {
        subscribeFrame.duplex = SignalingProtocol_js_1.SdkStreamServiceType.DUPLEX;
        for (var i = 0; i < settings.videoStreamDescriptions.length; i++) {
          // Non-simulcast use DefaultVideoStreamIndex.localStreamDescriptions
          // which is the exact old behavior
          var streamDescription = settings.videoStreamDescriptions[i].clone();
          streamDescription.attendeeId = settings.attendeeId;
          subscribeFrame.sendStreams.push(streamDescription.toStreamDescriptor());
        }
      }
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.SUBSCRIBE;
      message.sub = subscribeFrame;
      this.sendMessage(message);
    }
  }, {
    key: "remoteVideoUpdate",
    value: function remoteVideoUpdate(addedOrUpdated, removed) {
      var remoteVideoUpdate = SignalingProtocol_js_1.SdkRemoteVideoUpdateFrame.create();
      remoteVideoUpdate.addedOrUpdatedVideoSubscriptions = addedOrUpdated.map(this.convertVideoSubscriptionConfiguration);
      remoteVideoUpdate.removedVideoSubscriptionMids = removed;
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.REMOTE_VIDEO_UPDATE;
      message.remoteVideoUpdate = remoteVideoUpdate;
      this.sendMessage(message);
    }
  }, {
    key: "convertVideoSubscriptionConfiguration",
    value: function convertVideoSubscriptionConfiguration(config) {
      var signalConfig = new SignalingProtocol_js_1.SdkVideoSubscriptionConfiguration();
      signalConfig.mid = config.mid;
      signalConfig.attendeeId = config.attendeeId;
      signalConfig.streamId = config.streamId;
      return signalConfig;
    }
  }, {
    key: "leave",
    value: function leave() {
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.LEAVE;
      message.leave = SignalingProtocol_js_1.SdkLeaveFrame.create();
      this.sendMessage(message);
      this.logger.debug(function () {
        return 'sent leave';
      });
    }
  }, {
    key: "sendClientMetrics",
    value: function sendClientMetrics(clientMetricFrame) {
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.CLIENT_METRIC;
      message.clientMetric = clientMetricFrame;
      this.sendMessage(message);
    }
  }, {
    key: "sendDataMessage",
    value: function sendDataMessage(messageFrame) {
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.DATA_MESSAGE;
      message.dataMessage = messageFrame;
      this.sendMessage(message);
    }
  }, {
    key: "closeConnection",
    value: function closeConnection() {
      var _this2 = this;
      var _a, _b;
      if (this.webSocket.readyState() !== WebSocketReadyState_1.default.None && this.webSocket.readyState() !== WebSocketReadyState_1.default.Closed) {
        this.isClosing = true;
        this.sendEvent(new SignalingClientEvent_1.default(this, SignalingClientEventType_1.default.WebSocketClosing, null));
        // Continue resetting the connection even if SDK does not receive the "close" event.
        var scheduler = new TimeoutScheduler_1.default(DefaultSignalingClient.CLOSE_EVENT_TIMEOUT_MS);
        var _handler = function handler(event) {
          var _a, _b;
          /* istanbul ignore next */
          (_b = (_a = _this2.webSocket).removeEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, 'close', _handler);
          scheduler.stop();
          _this2.closeEventHandler(event);
        };
        // Remove the existing close handler to prevent SDK from opening a new connection.
        /* istanbul ignore next */
        (_b = (_a = this.webSocket).removeEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, 'close', this.closeEventHandler);
        this.webSocket.addEventListener('close', _handler);
        scheduler.start(function () {
          // SDK has not received the "close" event on WebSocket for two seconds.
          // Handle a fake close event with 1006 to indicate that the client abnormally closed the connection.
          _handler(new CloseEvent('close', {
            wasClean: false,
            code: 1006,
            reason: '',
            bubbles: false
          }));
        });
        this.webSocket.close();
        this.deactivatePageUnloadHandler();
      } else {
        this.logger.info('no existing signaling client connection needs closing');
        this.serviceConnectionRequestQueue();
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      return this.webSocket.readyState() === WebSocketReadyState_1.default.Open && !this.isClosing && this.wasOpened;
    }
  }, {
    key: "mute",
    value: function mute(muted) {
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.AUDIO_CONTROL;
      var audioControl = SignalingProtocol_js_1.SdkAudioControlFrame.create();
      audioControl.muted = muted;
      message.audioControl = audioControl;
      this.sendMessage(message);
    }
  }, {
    key: "pause",
    value: function pause(streamIds) {
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.PAUSE;
      message.pause = SignalingProtocol_js_1.SdkPauseResumeFrame.create();
      message.pause.streamIds = streamIds;
      this.sendMessage(message);
    }
  }, {
    key: "resume",
    value: function resume(streamIds) {
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.RESUME;
      message.pause = SignalingProtocol_js_1.SdkPauseResumeFrame.create();
      message.pause.streamIds = streamIds;
      this.sendMessage(message);
    }
  }, {
    key: "resetConnection",
    value: function resetConnection() {
      this.webSocket.destroy();
      this.wasOpened = false;
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(message) {
      message.timestampMs = Date.now();
      this.logger.debug(function () {
        return "sending: ".concat(JSON.stringify(message));
      });
      var buffer = this.prependWithFrameTypeRTC(SignalingProtocol_js_1.SdkSignalFrame.encode(message).finish());
      if (this.ready()) {
        if (!this.webSocket.send(buffer)) {
          this.sendEvent(new SignalingClientEvent_1.default(this, SignalingClientEventType_1.default.WebSocketSendMessageFailure, null));
          return;
        }
        this.sendEvent(new SignalingClientEvent_1.default(this, SignalingClientEventType_1.default.WebSocketSentMessage, null));
      } else {
        this.sendEvent(new SignalingClientEvent_1.default(this, SignalingClientEventType_1.default.WebSocketSkippedMessage, null));
      }
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(inBuffer) {
      var message;
      try {
        message = SignalingProtocol_js_1.SdkSignalFrame.decode(inBuffer);
      } catch (e) {
        this.logger.info("failed to decode: ".concat(inBuffer));
        this.sendEvent(new SignalingClientEvent_1.default(this, SignalingClientEventType_1.default.ProtocolDecodeFailure, null));
        return;
      }
      this.logger.debug(function () {
        return "received: ".concat(JSON.stringify(message));
      });
      if (this.webSocket.readyState() === WebSocketReadyState_1.default.Open) {
        this.sendEvent(new SignalingClientEvent_1.default(this, SignalingClientEventType_1.default.ReceivedSignalFrame, message));
      } else {
        this.logger.info("skipping notification of message since WebSocket is not open: ".concat(JSON.stringify(message)));
      }
    }
  }, {
    key: "stripFrameTypeRTC",
    value: function stripFrameTypeRTC(inBuffer) {
      var frameType = inBuffer[0];
      // TODO: change server frame type to send 0x05
      if (frameType !== DefaultSignalingClient.FRAME_TYPE_RTC && frameType !== 0x02) {
        this.logger.warn("expected FrameTypeRTC for message but got ".concat(frameType));
      }
      return inBuffer.slice(1);
    }
  }, {
    key: "prependWithFrameTypeRTC",
    value: function prependWithFrameTypeRTC(inBuffer) {
      var outBuffer = new Uint8Array(inBuffer.length + 1);
      outBuffer[0] = DefaultSignalingClient.FRAME_TYPE_RTC;
      outBuffer.set(inBuffer, 1);
      return outBuffer;
    }
  }, {
    key: "serviceConnectionRequestQueue",
    value: function serviceConnectionRequestQueue() {
      if (this.connectionRequestQueue.length === 0) {
        this.logger.info('no connection requests to service');
        return;
      }
      var request = this.connectionRequestQueue.shift();
      this.logger.info("opening connection to ".concat(request.url()));
      this.isClosing = false;
      this.webSocket.create(request.url(), request.protocols());
      this.setUpEventListeners();
      this.sendEvent(new SignalingClientEvent_1.default(this, SignalingClientEventType_1.default.WebSocketConnecting, null));
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(event) {
      var _this3 = this;
      switch (event.type) {
        case SignalingClientEventType_1.default.WebSocketMessage:
        case SignalingClientEventType_1.default.ReceivedSignalFrame:
        case SignalingClientEventType_1.default.WebSocketSentMessage:
          this.logger.debug(function () {
            return "notifying event: ".concat(SignalingClientEventType_1.default[event.type]);
          });
          break;
        case SignalingClientEventType_1.default.WebSocketSkippedMessage:
          this.logger.debug(function () {
            return "notifying event: ".concat(SignalingClientEventType_1.default[event.type], ", websocket state=").concat(WebSocketReadyState_1.default[_this3.webSocket.readyState()]);
          });
          break;
        default:
          this.logger.info("notifying event: ".concat(SignalingClientEventType_1.default[event.type]));
          break;
      }
      var _iterator = _createForOfIteratorHelper(this.observerQueue),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          observer.handleSignalingClientEvent(event);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "setUpEventListeners",
    value: function setUpEventListeners() {
      var _this4 = this;
      this.webSocket.addEventListener('open', function () {
        _this4.activatePageUnloadHandler();
        _this4.wasOpened = true;
        _this4.sendEvent(new SignalingClientEvent_1.default(_this4, SignalingClientEventType_1.default.WebSocketOpen, null));
      });
      this.webSocket.addEventListener('message', function (event) {
        _this4.sendEvent(new SignalingClientEvent_1.default(_this4, SignalingClientEventType_1.default.WebSocketMessage, null));
        _this4.receiveMessage(_this4.stripFrameTypeRTC(new Uint8Array(event.data)));
      });
      this.webSocket.addEventListener('close', this.closeEventHandler);
      this.webSocket.addEventListener('error', function () {
        if (_this4.isClosing && !_this4.wasOpened) {
          _this4.logger.info('ignoring error closing signaling while connecting');
          return;
        }
        if (_this4.wasOpened) {
          _this4.logger.error('received error while connected');
          _this4.sendEvent(new SignalingClientEvent_1.default(_this4, SignalingClientEventType_1.default.WebSocketError, null));
        } else {
          _this4.logger.error('failed to connect');
          _this4.sendEvent(new SignalingClientEvent_1.default(_this4, SignalingClientEventType_1.default.WebSocketFailed, null));
        }
      });
    }
  }, {
    key: "activatePageUnloadHandler",
    value: function activatePageUnloadHandler() {
      var _this5 = this;
      this.unloadHandler = function () {
        _this5.leave();
      };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var GlobalAny = global;
      GlobalAny['window'] && GlobalAny['window']['addEventListener'] && window.addEventListener('unload', this.unloadHandler);
    }
  }, {
    key: "deactivatePageUnloadHandler",
    value: function deactivatePageUnloadHandler() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var GlobalAny = global;
      GlobalAny['window'] && GlobalAny['window']['addEventListener'] && window.removeEventListener('unload', this.unloadHandler);
      this.unloadHandler = null;
    }
  }, {
    key: "generateNewAudioSessionId",
    value: function generateNewAudioSessionId() {
      var num = new Uint32Array(1);
      var randomNum = window.crypto.getRandomValues(num);
      return randomNum[0];
    }
  }, {
    key: "promoteToPrimaryMeeting",
    value: function promoteToPrimaryMeeting(credentials) {
      var signaledCredentials = SignalingProtocol_js_1.SdkMeetingSessionCredentials.create();
      signaledCredentials.attendeeId = credentials.attendeeId;
      signaledCredentials.externalUserId = credentials.externalUserId;
      signaledCredentials.joinToken = credentials.joinToken;
      var primaryMeetingJoin = SignalingProtocol_js_1.SdkPrimaryMeetingJoinFrame.create();
      primaryMeetingJoin.credentials = signaledCredentials;
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.PRIMARY_MEETING_JOIN;
      message.primaryMeetingJoin = primaryMeetingJoin;
      this.sendMessage(message);
    }
  }, {
    key: "demoteFromPrimaryMeeting",
    value: function demoteFromPrimaryMeeting() {
      var primaryMeetingLeave = SignalingProtocol_js_1.SdkPrimaryMeetingLeaveFrame.create();
      var message = SignalingProtocol_js_1.SdkSignalFrame.create();
      message.type = SignalingProtocol_js_1.SdkSignalFrame.Type.PRIMARY_MEETING_LEAVE;
      message.primaryMeetingLeave = primaryMeetingLeave;
      this.sendMessage(message);
    }
  }]);
  return DefaultSignalingClient;
}();
exports.default = DefaultSignalingClient;
DefaultSignalingClient.FRAME_TYPE_RTC = 0x5;
DefaultSignalingClient.CLOSE_EVENT_TIMEOUT_MS = 2000;
DefaultSignalingClient.CLIENT_SUPPORTS_COMPRESSION = true;